import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { RoutesConstants } from '@shared/constants';
import { EnumModel } from '@shared/models/enum-model';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss']
})
export class DropdownMenuComponent {
  SharedConstants: RoutesConstants;

  @Input() iconName: string;
  @Input() dropdownText: string;
  @Input() labelTranslationKey = '';
  @Input() dropdownValue: EnumModel[];

  @Input() selectedValue = RoutesConstants.ALL;
  @Output() selectedValueChange = new EventEmitter();

  onSelectedValueChange(event: MatSelectChange): void {
    this.selectedValue = event.value;
    this.selectedValueChange.emit(event);
  }
}

